<template>
  <div class="input-text text-left datepicker">
    <div v-if="error || hlGetValidationError()" class="error-message text-danger">
      <span class="error-icon"></span>
      {{ error || hlGetValidationError() }}
    </div>

    <!-- flags -->
    <!--<pre>{{inputFlags}}</pre>-->
    <!-- -->
    <!--<span
      v-if="(inputFlags.touched && inputFlags.validated && inputFlags.valid && inputFlags.changed) || (inputFlags.pristine && inputFlags.validated && inputFlags.valid && inputFlags.untouched)"
      class="input-icon"
      :class="{ 'has-label': label, 'no-label': !label }"
    ></span>-->

    <input
      class="d-none"
      :value="value"
      :name="name"
      v-validate="hlGetValidationRule()"
      :data-vv-as="label"
      @input="updateValue"
    />

    <datepicker
      class="hideReadOnly"
      :class="{ input: true, 'is-invalid': error || !!hlGetValidationError() }"
      :disabled-dates="disabledDates"
      :monday-first="true"
      format="dd.MM.yyyy"
      :language="getLanguage"
      :placeholder="getPlaceholder"
      :bootstrap-styling="true"
      @input="updateValue"
      @cleared="clearValue"
      @blur="$emit('blur')"
      :disabled="disabled"
      :typeable="typeable"
      :value="value"
      :clear-button="clearable"
    />

    <a-label :optional="optional" v-if="label">{{ label }}</a-label>
  </div>
</template>

<script>
import Label from '@modules/design-system/components/atoms/labels/Label.vue';
import I18nOperations from '@modules/i18n/utils/I18nOperations.class';
import hlValidation from '@modules/husleie-framework/src/mixins/hlValidation';
import * as moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  mixins: [hlValidation],
  components: {
    Datepicker,
    'a-label': Label,
  },

  props: {
    name: String,
    value: [Date, String],
    label: {
      type: String,
    },
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledDates: {
      type: Object,
      default: undefined,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    typeable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'lg',
    },
    error: {
      type: String,
    },
  },

  methods: {
    updateValue(event) {
      this.$emit('input', moment(event).format('YYYY-MM-DD'));
    },
    clearValue() {
      this.$emit('input', null);
    },
  },

  computed: {
    inputFlags() {
      return (this._hl_fields && this._hl_fields[this.name]) || {};
    },
    getPlaceholder() {
      return this.placeholder ? this.placeholder : I18nOperations.getDateLabelFormat(this.$i18n.locale);
    },
    getLanguage() {
      return I18nOperations.getDatePickerTranslations(this.$i18n.locale);
    },
  },
};
</script>

<style lang="scss">
.datepicker {
  ::placeholder {
    color: $husleie-text-dark;
  }
}
.hideReadOnly {
  padding-top: 3px;
}
.hideReadOnly div {
  input[readonly] {
    background-color: white;
    opacity: 1;
  }
}

.is-invalid input {
  border: 1px solid $danger;
}
.is-valid input {
  border: 1px solid $success;
}
.vdp-datepicker__calendar {
  z-index: 1040 !important;
}
</style>

<style scoped lang="scss">
.input-text {
  display: flex;
  flex-direction: column-reverse;
  position: relative;

  p {
    margin-top: 1rem;
  }

  input {
    padding-right: 45px;
  }

  label {
    font-size: 0.8em;
    color: $husleie-text-light;
  }

  input {
    &:focus {
      + label {
        color: $husleie-text-medium;
      }
    }
  }

  .error-message {
    font-size: 0.8em;
    padding: 0.8rem 1rem;
    box-shadow: $box-shadow-2;
    border-radius: $border-radius;

    .error-icon {
      display: inline-block;
      position: relative;
      top: 3px;
      width: 16px;
      height: 16px;
      background: $danger;
      background-image: url('../../../../icons/custom/cross.svg');
      background-size: 8px;
      background-position: center center;
      background-repeat: no-repeat;
      border-radius: 50%;
      color: #ffffff;
      font-size: 0.8em;
      margin-right: 0.8em;
      text-align: center;
    }
  }
}

.has-icon {
  padding-right: 50px;
}

.input-icon {
  background-color: $primary;
  background-image: url('../../../../icons/custom/checkmark.svg');
  background-size: 12px;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  right: 0.8rem;
  z-index: 2;
  display: block;
  width: 22px;
  height: 22px;
  line-height: 34px;
  text-align: center;
  pointer-events: none;
}

.has-label {
  top: 2.6rem;
}

.no-label {
  top: 1rem;
}
</style>
